import { Exception } from '@web/common';

export class BooleanTypeNotFoundException extends Exception {
  public constructor(message = 'Boolean type not found.') {
    super(message);
  }
}
